import { parse } from "graphql";
const PROFILE_FIELDS = `
    fields {
        name
        value
        type
        description
        label
        required
        match
        infoType
        readOnly
    }
    countrySubDivisions {
        Name
        Code
    }
    verificationConfigured,
    verified,
    verificationAttemptRemaining
    idVerificationUIState
    documentVerification {
        transactionId
        created
        result
    }
    documentVerificationRetries
    documentVerificationAttemptRemaining
`;

// For expert-app profile
export const GET_PROFILE_FIELDS = parse(`
    query getProfileFields {
        getProfileFields {
            ${PROFILE_FIELDS}
        }
    }
`);

// For crowd-manager user profile
export const GET_USER_PROFILE_FIELDS = parse(`
    query getProfileFieldsForUser($userName: String!) {
        getProfileFieldsForUser(userName: $userName) {
            ${PROFILE_FIELDS}
        }
    }
`);
export const VERIFY_IDENTITY = parse(`
    mutation verifyIdentity($tncAccepted: Boolean!, $fields: [UpdateProfileInput]) {
        verifyIdentity(
            tncAccepted: $tncAccepted
            fields: $fields
        ) {
            ${PROFILE_FIELDS}
        }
    }
`);
export const RECORD_USER_DOCUMENT_VERIFICATION = parse(`
    mutation recordUserDocumentVerification($transactionId:String!) {
        recordUserDocumentVerification(
            transactionId: $transactionId
        ) {
            documentVerification {
                firstName
                lastName
                dayOfBirth
                monthOfBirth
                country
                yearOfBirth
                transactionId
                result
                created
            }
        }
    }
`);